/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./nGiftHead.vue?vue&type=template&id=289660c6&scoped=true"
import script from "./nGiftHead.vue?vue&type=script&lang=js"
export * from "./nGiftHead.vue?vue&type=script&lang=js"
import style0 from "./nGiftHead.vue?vue&type=style&index=0&id=289660c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289660c6",
  null
  
)

export default component.exports